import Box from '@material-ui/core/Box';

import { warningsListLabels } from 'utils/menus/menuCopy';

import useStyles from './styles';

interface Props {
  t: (value: string) => string;
}

function WarningsList({ t }: Props) {
  const classes = useStyles();

  return (
    <Box display="grid" gridRowGap={4} pl={10} pr={12}>
      {warningsListLabels.map((item, index) => (
        <Box key={item} alignItems="center" display="flex" gridGap={24}>
          <Box className={classes.warningNumber}>{index + 1}</Box>

          <Box component="p" fontSize={18}>
            {t(item)}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default WarningsList;
